angular.module('rjmNg.directives').directive "currencyConverter", [
  "currencyService"
  (currencyService) ->
    restrict: "E"
    templateUrl: "directive.currencyConverter.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      ownerColumn: "="
      timestampColumn: "="
      sourceColumn: "="
      targetCurrency: "="
      startCurrencyColumn: "="
      tableId: "="
    controller: [
      () ->
        view = @
        view.CURRENCIES = null
        view.loadingCurrencies = true

        currencyService.fetch().then((response) ->
          view.loadingCurrencies = false
          view.CURRENCIES = response.data
        ,
          (error) ->
            view.loadingCurrencies = false
        )

        view.types =
          string: ["string"]
          date: ["inst"]
          currency: ["decimal"]

        @$onInit = ->
          view.sourceColumn ?=
            table: view.tableId
            column: view.sourceColumn

          view.timestampColumn ?=
            table: view.tableId
            column: view.timestampColumn

          view.targetCurrency ?= null

          view.startCurrencyColumn ?=
            table: view.tableId
            column: view.startCurrencyColumn

        return view
    ]
]

